<template>
  <el-dialog
    append-to-body
    v-dialogDrag
    title="选择风险点"
    class="mid-dialog"
    :visible.sync="pointProps.visible"
    :close-on-click-modal="false"
  >
    <div class="flex mb-10px mr-10px">
      <el-input
        size="small"
        class="mr-10px !w-50"
        placeholder="请输入关键字"
        v-model="searchData.keywords"
        clearable
      ></el-input>
      <el-select
        size="small"
        class="mr-10px !w-50"
        filterable
        placeholder="请选择区域"
        v-model="searchData.areaId"
        clearable
      >
        <el-option
          v-for="item in areaList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        ></el-option>
      </el-select>
      <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择是否评价"
        v-model="searchData.isAppraise"
        clearable
      >
        <el-option
          v-for="item in isValuateList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select>
      <!-- <el-select
        size="small"
        class="mr-10px !w-50"
        placeholder="请选择风险点类型"
        v-model="searchData.riskPointType"
        @change="chooseType"
        disabled
        filterable
      >
        <el-option
          v-for="item in riskPointList"
          :key="item.code"
          :label="item.displayName"
          :value="item.code"
        ></el-option>
      </el-select> -->
      <department-select
        ref="departmentSelect"
        class="mr-10px !w-50"
        v-model="searchData.belongUnit"
      ></department-select>
      <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
    </div>
    <el-table
      :data="dataList"
      border
      class="w-full mb-20px"
      :height="tableHeight"
      stripe
      v-loading="tableLoading"
      @selection-change="handleSelection"
    >
      <el-table-column
        type="selection"
        :selectable="isDisabled"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column
        label="风险点名称"
        align="center"
        prop="riskPointName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="风险点编号"
        align="center"
        prop="riskPointNumber"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="风险点类型"
        align="center"
        prop="riskPointType"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="区域"
        align="center"
        prop="activityArea"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="所属单位"
        align="center"
        prop="belongUnitName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="是否评价过"
        align="center"
        prop="isAppraiseText"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="风险上报人"
        align="center"
        prop="reportName"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      background
      @size-change="tableSizeChange"
      @current-change="tableCurrentChange"
      :current-page.sync="pageConfig.SkipCount"
      :page-size.sync="pageConfig.MaxResultCount"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[15, 30, 45, 60, 75, 90]"
      :total="totalCount"
      class="float-right mt-20px ml-10px"
    ></el-pagination>
    <div slot="footer" class="dialog-footer flex justify-center items-center">
      <div class="flex justify-center">
        <el-button type="primary" size="small" @click="submitForm">确定</el-button>
        <el-button @click="closeDialog" size="small">取消</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { SourcesDangerRecognitionPlanTaskApi } from '@wiz-api/double-prevention-management'
import { AreaApi } from '@wiz-api/area-management'
import DepartmentSelect from '@/components/safety/DepartmentSelect/DepartmentSelect'

const areaApi = new AreaApi()
const sourcesDangerRecognitionPlanTaskApi = new SourcesDangerRecognitionPlanTaskApi()
export default {
  name: 'choose-risk-point-form',
  components: {
    DepartmentSelect,
  },
  props: {
    FormData: {
      type: Object,
      default: () => {},
    },
    /**
     * @description: 上传传递的参数
     * @param {控制弹窗显示隐藏} visible
     * @return {*}
     */
    pointProps: {
      type: Object,
      default: () => {
        return {
          visible: false,
        }
      },
    },
    // 已选风险点集合
    taskIds: {
      type: Array,
      default: () => {
        return []
      },
    },
    types: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      tableLoading: false,
      areaList: [],
      selectionData: [],
      dataList: [],
      planStatusList: [],
      isValuateList: [
        {
          code: true,
          displayName: '是',
        },
        {
          code: false,
          displayName: '否',
        },
      ],
      riskPointList: [
        {
          code: 1,
          displayName: '设备设施类',
        },
        {
          code: 0,
          displayName: '设备设施类',
        },
      ],
      searchData: {
        keywords: '',
        belongUnit: undefined,
        areaId: undefined,
        isAppraise: null,
        riskPointType: null,
      },
      totalCount: 0,
      pageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
    }
  },
  created() {
    // 获取区域列表
    this.getAreaList()
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 120px)'
    },
  },
  watch: {
    types: {
      handler(newVal) {
        this.$nextTick(() => {
          this.searchData.riskPointType = newVal
          this.getList()
        })
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 风险点切换事件
    chooseType(value) {
      this.searchData = {
        keywords: '',
        belongUnit: undefined,
        areaId: undefined,
        isAppraise: null,
        riskPointType: value,
      }
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 禁用复选框 0禁用 1不禁用
    isDisabled(row) {
      if (this.taskIds?.length > 0 && this.taskIds.includes(row.riskPointId)) {
        return 0
      }
      return 1
    },
    // 获取区域列表
    async getAreaList() {
      const [err, res] = await areaApi.getList({
        skipCount: 0,
        maxResultCount: 999,
      })
      if (!err) {
        this.areaList = res.items || []
      }
    },
    // 页码改变
    tableSizeChange(MaxResultCount) {
      this.pageConfig.MaxResultCount = MaxResultCount
      this.getList()
    },
    // 页数改变
    tableCurrentChange(SkipCount) {
      this.pageConfig.SkipCount = SkipCount
      this.getList()
    },
    // 搜索
    handleSearch() {
      this.pageConfig.SkipCount = 1
      this.getList()
    },
    // 选中
    handleSelection(values) {
      this.selectionData = values
    },
    // 表单提交
    async submitForm() {
      if (this.selectionData?.length === 0) {
        this.$message({
          showClose: true,
          message: '请选择风险点数据',
          type: 'warning',
        })
        return
      }
      const selectionData = _.map(this.selectionData, (item) => {
        return {
          riskActivityRelationalId: item.riskPointId,
          riskPointName: item.riskPointName,
          riskPointType: this.searchData.riskPointType,
          riskRecognitionEvaluationLeaderId: '',
          evaluateMethod: '',
          recognitionMethod: '',
        }
      })
      this.$emit('add-risk-point', selectionData)
      // 点击确定后,清空选择数据
      this.selectionData = []
    },
    // 关闭弹窗
    closeDialog() {
      this.pointProps.visible = false
      this.$emit('cancel')
    },
    // 获取风险点列表
    async getList() {
      this.selectionData = []
      const data = {
        maxResultCount: this.pageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.pageConfig.SkipCount - 1) * this.pageConfig.MaxResultCount, // 跳过多少条
        ...this.searchData,
      }
      this.tableLoading = true
      const [err, res] = await sourcesDangerRecognitionPlanTaskApi.riskPointPagedListQuery(data)
      if (!err) {
        this.dataList = res.items
        this.totalCount = res.totalCount
      }
      this.tableLoading = false
    },
  },
}
</script>

<style scoped lang="scss"></style>
